import React, { useContext, useEffect, useState } from "react";
//import classes from "./pricingDropdowns.module.scss";
import classes from "../dashboardComponents/DashboardComponents.module.scss";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpIcon from '@mui/icons-material/Help';
import { OrgIdContext } from "../../store/orgId_context";
import { useTranslation } from "react-i18next";
import OutboxIcon from '@mui/icons-material/Outbox';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import QrCodeIcon from '@mui/icons-material/QrCode';
import Button from "../UI/Button";
import { Dialog, DialogActions, DialogContent, DialogTitle, Switch } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import { CustomerRelations } from "../../store/orgId_context";
import { E2Data, DDD } from "../../lib/ddd/ddd";
import { useQuery } from "@tanstack/react-query";
import { ThemeContext, Themes } from "../../store/ThemeContext";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const e2Data_EU_AOrg = new E2Data("EU_AOrg");
const ddd = new DDD(apiRequestAddress);

const Preferences = () => {
    const {sessionInfo, customerRelation, setCustomerRelationHandler, aboutOrgId} = useContext(OrgIdContext);
    const { theme } = useContext(ThemeContext);
    const isDefaultTheme = theme === Themes.Default;
    const [confirmDialog, setConfirmDialog] = useState();
    const [autoRecharge, setAutoRecharge] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const {t} = useTranslation();

    const {isPending, data, refetch} = useQuery({
        queryKey: ['Auth.GetSessionInfo', ["Accounts"]],
        queryFn: () => ddd.Rpc_ExecuteMethod("Auth.GetSessionInfo", ["Accounts"]),
        staleTime: "Infinity"
    })

    const {isPending : isLoading, data : queryData, refetch:refetchOrg} = useQuery({
        queryKey: ['Data.GetEntityData' , e2Data_EU_AOrg.GetParamsObject()],
        queryFn: () => e2Data_EU_AOrg.GetData()
    });

    useEffect(() => {
        if(queryData?.result?.data?.[0]?.InvoiceReceiverId)
            setSelectedOption(queryData?.result?.data?.[0]?.InvoiceReceiverId);
        else
            setSelectedOption(null);
    },[queryData]);

    const onCancelConfirm = () => {
        setConfirmDialog(null);
    }

    const onConfirmPackageChange = () => {
        setConfirmDialog(null);
        if(queryData?.result?.data?.[0]?.ClientTypeDef === "Company"){
            ChangeRelation(null);
        }else{
            ChangeRelation("Company");
        }
    }

    const onAutoRechargeClick = () => {
        setConfirmDialog(true);
    }
    const ChangeRelation = (relation) => {
        e2Data_EU_AOrg.filter = `Id="${aboutOrgId}"`;
        e2Data_EU_AOrg.values = {ClientTypeDef : relation}
        e2Data_EU_AOrg.Modify().then(() => {
            refetchOrg();
        });;
        ddd.InvalidateSessionExtensions();
        
    }

    const handleChange = (e) => {
        e2Data_EU_AOrg.filter = `Id="${aboutOrgId}"`;
        e2Data_EU_AOrg.values = {InvoiceReceiverId : e.target.value}
        e2Data_EU_AOrg.Modify().then(() => {
            refetchOrg();
        });
    };

    return (<>
        <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={confirmDialog}>
            <DialogTitle>{t("Confirm change")}</DialogTitle>
            <DialogContent dividers>
            {t("Are you certain you wish the change the bussiness relationship with us?")}
            </DialogContent>
            <DialogActions>
                <Button className="ps-2 pe-2" autoFocus onClick={onCancelConfirm}>
                {t("Cancel")}
                </Button>
                <Button className="ps-2 pe-2" onClick={onConfirmPackageChange}>Ok</Button>
            </DialogActions>
        </Dialog>
        <Row>
            <Col className="col-md-6">
            <div className={classes.container} style={{maxHeight:"none", height:"auto"}}>
                <h4>{t(isDefaultTheme ? "DDD Services Invoice" : "Services Invoice")}</h4>
                <div className="mt-1 fs-8">
                    {t(isDefaultTheme
                        ? "If you wish to change the information on invoices that are issued by DDD Invoices for your use of DDD Invoices services, select one of your other companies you have registered."
                        : "If you wish to receive invoices to some other company you have registered on our platform, select the company in the dropdown below."
                    )}
                </div>
                <div className="mt-3">
                    <label htmlFor="dynamic-select" className="me-2">{t("Choose an option")}:</label>
                    <select
                        id="dynamic-select"
                        value={selectedOption}
                        onChange={handleChange}
                        className={classes["companyInvoiceSelect"]}
                    >
                        <option value={null}>
                            {t("None")}
                        </option>
                        {data?.result?.AuthorizedOrganizations.map((item, index) => {
                            if (item.ClientType === null || item.ClientType === undefined || item.IsCustomer===true) return null;
                            return(
                            <option key={index} value={item.Id}>
                                {item.Title}
                            </option>
                            )
                        })}
                    </select>
                </div>
            </div>
            </Col>
        </Row>
        </>);
};

export default Preferences;
